<label>
  <input
    type="checkbox"
    name="switch"
    [(ngModel)]="checkbox"
    (ngModelChange)="handleModelChange()"
  />
  <div class="background">
    <div class="circle"></div>
  </div>
</label>
